import { render, staticRenderFns } from "./RightColumnImageConfig.vue?vue&type=template&id=596e6340&scoped=true&"
import script from "./RightColumnImageConfig.vue?vue&type=script&lang=js&"
export * from "./RightColumnImageConfig.vue?vue&type=script&lang=js&"
import style0 from "./RightColumnImageConfig.vue?vue&type=style&index=0&id=596e6340&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596e6340",
  null
  
)

export default component.exports